/** @format */

import { Component, Input, OnChanges, OnInit, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Profile } from 'src/app/models/profile';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: false,
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
	@Input() profileImg: Blob | string | null = null;
	@Input() profile!: Profile;
	@Input() isLoadingData = false;

	isTestEnv = false;

	base64ProfilePhoto: any;
	// isDelegatedAsManager: boolean = false;
	// isFutureDelegatedManager: boolean = false;

	private readonly _destroying$ = new Subject<void>();

	role: any = [];

	constructor(public router: Router, private changeDetectorRef: ChangeDetectorRef, private msalService: MsalService) {}

	ngOnInit(): void {
		this.getRoleFromMsal();
		this.isTestEnv = window.location.href.includes('https://tsuat.dnv.org/');
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ('string' === typeof this.profileImg) {
			this.base64ProfilePhoto = this.profileImg;
			this.getRoleFromMsal();
		} else if (this.profileImg) {
			const reader = new FileReader();
			reader.onloadend = () => {
				this.base64ProfilePhoto = reader.result;
			};
			reader.readAsDataURL(this.profileImg);
			this.getRoleFromMsal();
		}

		if (
			changes.profile &&
			changes.profile.currentValue &&
			changes.profile.previousValue &&
			changes.profile.currentValue.user.id !== changes.profile.previousValue.user.id
		) {
			this.role = [];
			this.getRoleFromMsal();
			this.changeDetectorRef.detectChanges();
		}
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	getRoleFromMsal(): void {
		if (this.msalService.instance && this.msalService.instance.getAllAccounts().length > 0) {
			let account = this.msalService.instance.getAllAccounts()[0];
			if (account.authorityType === 'MSSTS') {
				if (
					account.idTokenClaims &&
					account.idTokenClaims.roles &&
					account.idTokenClaims.preferred_username?.toLowerCase() === this.profile.user.upn.toLowerCase()
				) {
					this.role.push(...account.idTokenClaims.roles);
				}
			}
		}
	}

	isManagerOrTimeKeeper(): boolean {
		return this.isManager() || this.isTimeKeeper();
	}

	isAdmin(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'admin') {
				result = true;
			}
		});

		return result;
	}

	isManager(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'manager') {
				result = true;
			}
		});

		return result;
		// return true;
	}

	isTimeKeeper(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'timekeepers') {
				result = true;
			}
		});

		return result;
		// return true;
	}

	isCurrentActiveRoute(routePath: string) {
		if (routePath.toLowerCase().indexOf('team') > -1 || routePath.toLowerCase().indexOf('profiles')) {
			return this.router.url === routePath;
		}
		// for when other params appended to route
		return this.router.url.indexOf(routePath) > -1;
	}
}
